@if (isDesktop) {
<mat-menu
  #appMenu="matMenu"
  aria-labelledby="menu-label"
  class="main-menu-panel"
  backdropClass="main-menu-overlay"
  [hasBackdrop]="true"
>
  <ng-template matMenuContent>
    @if(selectedMenuItem) {
    <h3 role="presentation" class="menu-label" id="menu-label">
      {{ selectedMenuItem.label | content }}
    </h3>
    <ul
      role="menu"
      class="inner-menu-wrapper"
      [attr.aria-label]="selectedMenuItem.label | content"
      [ngStyle]="{
        'grid-template-rows':
          'repeat(' +
          getColumnItemCount(selectedMenuItem.components?.length ?? 0) +
          ', 1fr)'
      }"
    >
      @for (item of selectedMenuItem.components; track item) {
      <li role="none">
        <button
          mat-menu-item
          role="menuitem"
          class="inner-menu-item"
          [attr.data-automation]="'navigation_' + item.id.toLowerCase()"
          (click)="handleMenuItemClick($event, item, selectedMenuItem)"
        >
          <span class="menu-item-wrapper">
            <span class="menu-item-content"> {{ item.label | content }}</span>
            <i class="cm-icons cm-icons-angle-right" aria-hidden="true"></i>
          </span>
        </button>
      </li>
      }
    </ul>
    }
  </ng-template>
</mat-menu>
@if (isDesktop) {
<nav [attr.aria-label]="'lbl_header_menu' | content" #menuWrapperRef>
  <ul role="menubar" class="menu-wrapper">
    @for (menuItem of menuItemList; track menuItem) {
    <li role="none" #menuItemsRef>
      <ng-container
        [ngTemplateOutlet]="
          menuItem?.components?.length ? withSubmenu : withoutSubmenu
        "
        [ngTemplateOutletContext]="{ menuItem, menuRef: appMenu }"
      >
      </ng-container>
    </li>
    }
  </ul>
</nav>
} }

<ng-template #withoutSubmenu let-menuItem="menuItem">
  <button
    class="menu-item"
    role="menuitem"
    [attr.data-automation]="'navigation_' + menuItem.id?.toLowerCase()"
    (click)="handleMenuItemClick($event, menuItem)"
  >
    {{ menuItem.label | content }}
  </button>
</ng-template>

<ng-template #withSubmenu let-menuItem="menuItem" let-menuRef="menuRef">
  <button
    class="menu-item"
    role="menuitem"
    [matMenuTriggerFor]="menuRef"
    [attr.data-automation]="'navigation_' + menuItem.id?.toLowerCase()"
    (click)="handleMenuItemClick($event, menuItem)"
  >
    <span>{{ menuItem.label | content }}</span>
    @if (menuItem.components?.length) {
    <i class="cm-icons cm-icons-arrow-down" aria-hidden="true"></i>
    }
  </button>
</ng-template>
